/*
 * @version: 1.0
 * @author: fengziwei
 * @creatTime: 2024-03-04
 * @updateTime: 2024-05-06
 * @lastEditors: fengziwei
 * @Description :
 */
export default {
  'home.title': 'OpenDataLab provides high-quality open datasets for large models',
  'home.titleDesc': 'China Large model corpus Data Alliance open source data service designated platform',
  'home.title2': 'Pioneering open-source data platform for large AI model era',
  'home.platform': 'Platform Capacity',

  'home.platformA': 'Massive multimodal',
  'home.platformADesc': 'Covering 7 Major Topics, 50+ Data Types, 1500+ Task Types',
  'home.platformB': 'Format standardization',
  'home.platformBDesc':
    'Standardized dataset language for data annotation and online visualization of data distribution',
  'home.platformC': 'Open sharing',
  'home.platformCDesc':
    'Bringing together various data sources including public, original, and collaboratively built datasets',
  'home.platformD': 'Intelligent search',
  'home.platformDDesc':
    'Supporting intelligent retrieval of meta information in a conversational and multidimensional manner',
  'home.platformE': 'Structured presentation',
  'home.platformEDesc':
    'Building open-source intelligent data tools for unified management and statistical analysis of multimodal datasets',
  'home.platformF': 'High-speed download',
  'home.platformFDesc': 'No VPN required within the domestic cloud, unlimited downloads available via web, CLI/SDK',
  'home.partners': 'Partners',

  'home.recommend.industry': 'Featured Picks',

  'home.recommend.industry.type': 'Special Topic',
  'home.recommend.industry.largeModel.name': 'Large Model Corpus Alliance',
  'home.recommend.industry.largeModel.name.mobile': 'Corpus Alliance',
  'home.recommend.industry.largeModel.desc': 'Exclusive open source, first-rate data',
  'home.recommend.industry.largeModel.join': 'Join the Alliance',

  'home.recommend.industry.miniLang.name': 'Multi-language Corpus',
  'home.recommend.industry.miniLang.desc': 'Research cooperation, corpus development and utilization',
  'home.recommend.industry.miniLang.apply': 'Apply',

  'home.recommend.industry.dsdl.name': 'DSDL Standardization',
  'home.recommend.industry.dsdl.desc': 'Unified standard, visualized AI data',

  'home.recommend.industry.preChain.name': 'Pre-trained',
  'home.recommend.industry.preChain.desc': 'Launching large models, exploring diversity',

  'home.recommend.industry.fineTuning.name': 'Fine-tuning',
  'home.recommend.industry.fineTuning.desc': 'Optimizing large models, selecting fine-tuning sets',

  'home.recommend.industry.evaluation.name': 'Evaluation',
  'home.recommend.industry.evaluation.desc': 'Assessing large models, comprehensively validating performance',

  'home.recommend.hotList': 'Related Rankings Picks',
  'home.recommend.hotList.download': "This Week's Downloads",
  'home.recommend.hotList.viewCount': "This Week's Views",
  'home.recommend.hotList.recentRelease': "This Week's New Releases",

  'home.filtering.datasets': 'Filtering( {num} Datasets)',
  'home.filtering.all': 'Filtering All',

  'home.org.deploy.datasets': 'Published {num} Datasets',
  'home.recommend.organization': 'Collaborative Organization',
  'home.recommend.org.verification': 'Organization Verification',

  'home.section2.title': 'Datasets',
  'home.section5.title': 'LLM User'
};
